import { INDIAN_STATES } from "../employee-management/salary-structure/utils/ptStates";

export const CENTRAL_STATE_LABEL = "Central (All India)";

/** Mirror backend statutoryStateMap name → code. */
const STATE_NAME_TO_CODE = {
  Karnataka: "KA",
  "Andhra Pradesh": "AP",
  "Tamil Nadu": "TN",
  Kerala: "KL",
  Maharashtra: "MH",
  Telangana: "TS",
  Gujarat: "GJ",
  Delhi: "DL",
  "West Bengal": "WB",
  "Uttar Pradesh": "UP",
  Rajasthan: "RJ",
  Punjab: "PB",
  Haryana: "HR",
  "Madhya Pradesh": "MP",
  Odisha: "OD",
  Bihar: "BR",
  Jharkhand: "JH",
  Assam: "AS",
  Goa: "GA",
  Chhattisgarh: "CG",
  Uttarakhand: "UK",
  "Himachal Pradesh": "HP",
  "Jammu and Kashmir": "JK",
  Ladakh: "LA",
  "Andaman and Nicobar Islands": "AN",
  "Arunachal Pradesh": "AR",
  Chandigarh: "CH",
  "Dadra and Nagar Haveli and Daman and Diu": "DN",
  Lakshadweep: "LD",
  Manipur: "MN",
  Meghalaya: "ML",
  Mizoram: "MZ",
  Nagaland: "NL",
  Puducherry: "PY",
  Sikkim: "SK",
  Tripura: "TR",
  [CENTRAL_STATE_LABEL]: "IN",
};

export function stateLabelToCode(label) {
  if (!label) return "";
  if (STATE_NAME_TO_CODE[label]) return STATE_NAME_TO_CODE[label];
  if (/^[A-Z]{2,3}$/.test(String(label).trim())) return String(label).trim();
  return String(label).slice(0, 2).toUpperCase();
}

/**
 * Act dropdown / copy-from labels: omit leading state name once State is already chosen.
 * e.g. "Karnataka Shops & Commercial Establishment Act" → "Shops & Commercial Establishment Act"
 */
export function displayActLabel(label) {
  if (!label) return "";
  let text = String(label).trim();
  const states = [...INDIAN_STATES].sort((a, b) => b.length - a.length);
  for (const state of states) {
    const prefix = `${state} `;
    if (text.toLowerCase().startsWith(prefix.toLowerCase())) {
      text = text.slice(prefix.length).trim();
      break;
    }
  }
  return text;
}

/** All states + Central for alias modal (branch states merged in, not replacing). */
export function allStatutoryStateOptions(branchStates = []) {
  const merged = new Set([
    CENTRAL_STATE_LABEL,
    ...INDIAN_STATES,
    ...(branchStates || []).filter(Boolean),
  ]);
  return [...merged].sort((a, b) => {
    if (a === CENTRAL_STATE_LABEL) return -1;
    if (b === CENTRAL_STATE_LABEL) return 1;
    return a.localeCompare(b);
  });
}
